import React from 'react'

import styles from './styles'

const ProfileSidebar = props => <aside className={styles.sidebar}>{props.children}</aside>

export default ProfileSidebar
